import { render, staticRenderFns } from "./DraftView.vue?vue&type=template&id=5662b18a"
import script from "./DraftView.vue?vue&type=script&lang=js"
export * from "./DraftView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports